import { render, staticRenderFns } from "./imageTemplate.vue?vue&type=template&id=55ff2d52&scoped=true&"
import script from "./imageTemplate.vue?vue&type=script&lang=js&"
export * from "./imageTemplate.vue?vue&type=script&lang=js&"
import style0 from "./imageTemplate.vue?vue&type=style&index=0&id=55ff2d52&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55ff2d52",
  null
  
)

export default component.exports